import { formatPhoneNumber } from './utils/helpers'

export const DEMO_HIDE_PHONES_KEY = 'demoHidePhones'

type Listener = () => void

let hidePhones =
  typeof window !== 'undefined' && window.localStorage?.getItem(DEMO_HIDE_PHONES_KEY) === '1'

const listeners = new Set<Listener>()

export const isHidePhonesEnabled = (): boolean => hidePhones

export const setHidePhonesEnabled = (enabled: boolean): void => {
  hidePhones = enabled
  if (typeof window !== 'undefined') {
    if (enabled) {
      window.localStorage.setItem(DEMO_HIDE_PHONES_KEY, '1')
    } else {
      window.localStorage.removeItem(DEMO_HIDE_PHONES_KEY)
    }
  }
  listeners.forEach(listener => listener())
}

export const subscribeHidePhones = (listener: Listener): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Скрывает последние 4 цифры: 79991234567 → +7 (999) 123-**-** */
export const maskPhoneDigits = (phone?: string | null, hideLast = 4): string => {
  if (phone == null || phone === '') {
    return ''
  }

  const cleaned = String(phone).replace(/\D/g, '')
  if (!cleaned) {
    return String(phone)
  }

  if (cleaned.length <= hideLast) {
    return '*'.repeat(cleaned.length)
  }

  const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/)
  if (match) {
    return `+${match[1]} (${match[2]}) ${match[3]}-**-**`
  }

  return `${cleaned.slice(0, -hideLast)}${'*'.repeat(hideLast)}`
}

export const formatPhoneForDemo = (phone?: string | null): string => {
  if (phone == null || phone === '') {
    return ''
  }
  if (isHidePhonesEnabled()) {
    return maskPhoneDigits(phone)
  }
  return formatPhoneNumber(phone)
}
